import { useTranslation } from 'react-i18next'
export function Subscription() {
  const { t } = useTranslation()
  return <>{t('todoSubscription', 'TODO: Subscription')}</>;
}
